import CCSelector from './cc-selector.vue';
export { CCSelector };
